import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useBrandSalesManagerDeleteMutation } from 'api';
import { notification } from 'components';
import { ErrorMappingValueType } from 'typings';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const { id } = useParams();
  const [salesManagerDelete, { isLoading }] = useBrandSalesManagerDeleteMutation();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({ message: message });
    },
    [notificationApi]
  );

  const onRemoveConfirm = useCallback(
    async (manager: { id: string | undefined }) => {
      try {
        const { data, error }: any = await salesManagerDelete({
          salesManagerId: manager.id,
          brandId: id,
        });

        if (data?.success) {
          onDeleteModalClose();
          openNotificationWithIcon({
            type: 'success',
            message: 'The Sales Manager was successfully deleted.',
          });
        } else if (error?.data?.success === false) {
          const { data = {} } = error.data;
          Object.keys(data).forEach((_key: string) => {
            openNotificationWithIcon({
              type: 'error',
              message: data[_key],
            });
          });
        } else {
          openNotificationWithIcon({
            type: 'error',
            message: error?.data?.error || 'Something went wrong!',
          });
        }
      } catch (err) {
        console.error('Error deleting sales manager:', err);
        openNotificationWithIcon({
          type: 'error',
          message: 'An unexpected error occurred!',
        });
      }
    },
    [salesManagerDelete, openNotificationWithIcon, onDeleteModalClose, id]
  );

  return {
    onRemoveConfirm,
    contextHolder,
    isLoading,
  };
};
